import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../styles/tileGrid.css";

/**
 * Homepage "quick access to everything we offer" grid — a card grid on
 * desktop, a compact tappable list on mobile. Same responsive philosophy as
 * the navbar's mega dropdown (rich cards where there's room, a plain list
 * where there isn't), reused here for the page body rather than the nav.
 *
 * @param {{to: string, icon: object, title: string, description: string}[]} items
 */
export default function TileGrid({ items }) {
  return (
    <>
      <Row className="g-3 d-none d-md-flex">
        {items.map((item) => (
          <Col md={6} lg={4} key={item.title}>
            <Link to={item.to} className="tile-grid-card card h-100">
              <span className="tile-grid-head">
                <span className="tile-grid-icon">
                  <FontAwesomeIcon icon={item.icon} />
                </span>
                <h3 className="tile-grid-title">{item.title}</h3>
              </span>
              <p className="tile-grid-desc mb-0">{item.description}</p>
            </Link>
          </Col>
        ))}
      </Row>

      <div className="tile-grid-list d-md-none">
        {items.map((item) => (
          <Link to={item.to} className="tile-grid-list-item" key={item.title}>
            <span className="tile-grid-icon">
              <FontAwesomeIcon icon={item.icon} />
            </span>
            <span className="tile-grid-list-text">
              <span className="tile-grid-title">{item.title}</span>
              <span className="tile-grid-desc">{item.description}</span>
            </span>
          </Link>
        ))}
      </div>
    </>
  );
}
